import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useCMSApi } from '../../hooks/useCMSApi';
type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllCMS = (queryParams: Params) => {

  const { getAllCMS } = useCMSApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCMS', queryParams],
    queryFn: () => {
      return getAllCMS(queryParams);
    },
    retry:false
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

export const UseCreateCMS = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createCMS } = useCMSApi();
  return useMutation({
    mutationKey: ['CreateCMS'],
    mutationFn: (data: any) => createCMS(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'CMS created successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getCMS'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create CMS',
        'error'
      );
    },
  });
};

export const usePatchCMS = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useCMSApi();

  return useMutation({
    mutationKey: ['PatchCMS'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`CMS ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getCMS'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to block the CMS',
        'error'
      );
    },
  });
};

export const useDeleteCMS = () => {
  const queryClient = useQueryClient();
  const { deleteCMS } = useCMSApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteChoice'],
    mutationFn: (ids: string[]) => {
      return deleteCMS(ids);
    },
    onSuccess: (response: any) => {
      showMessage(response?.message || 'CMS deleted successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getCMS'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to delete CMS',
        'error'
      );
    },
  });
};

export const useEditCMS = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editCMS } = useCMSApi();

  return useMutation({
    mutationKey: ['EditSubAdmin'],
    mutationFn: ({ id, data }: { id: string; data: any }) => editCMS(id, data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'CMS Updated successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getCMS'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to update the CMS',
        'error'
      );
    },
  });
};
